import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/theme/bg_bonus_bonus.png'
import _imports_1 from '@/assets/theme/i_money.png'
import _imports_2 from '@/assets/theme/mice.png'
import _imports_3 from '@/assets/theme/i_close.png'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "popupContainer" }
const _hoisted_3 = { class: "taskListContainer" }
const _hoisted_4 = { class: "Cardtitle" }
const _hoisted_5 = { class: "amountText" }
const _hoisted_6 = {
  key: 1,
  class: "container"
}
const _hoisted_7 = { class: "configContainer" }
const _hoisted_8 = {
  key: 0,
  width: "100%",
  style: {"margin-top":"-80px"},
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = { class: "ConfigDetailContainer" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "bonusAmount" }
const _hoisted_12 = { class: "secondPopTitle" }
const _hoisted_13 = { class: "tabelContainer" }
const _hoisted_14 = { class: "footerText" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "headTitle" }
const _hoisted_17 = {
  class: "secondPopTitle",
  style: {"padding":"15px 0"}
}
const _hoisted_18 = { class: "headBar" }
const _hoisted_19 = { class: "numberText" }
const _hoisted_20 = {
  class: "secondPopTitle",
  style: {"padding":"5px 0 15px"}
}
const _hoisted_21 = { class: "footerText" }

import { ref, computed, onMounted } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useUserStore } from '@/stores/user'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { handleMenuClick } from '@/view/components/supportFunction'
import { formatCurrency } from '@/utils/commonFunction'

export default /*@__PURE__*/_defineComponent({
  __name: 'backgroundRecharge',
  emits: ['handleShowTreasurePopup', 'getClaim'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const showIndex = ref(0)
const amountTemplates = ref<any[]>(userStore.pendingBackendRecharge?.config.amountTemplates)
const emits = __emit
const open = () => {
    show.value = true
}
const close = () => {
    if (userStore.pendingBackendRecharge?.config.cannotTurnOff == 0) {
        show.value = false
        showIndex.value = 0
    }
}

const directClose = () => {
    show.value = false
    showIndex.value = 0
}

const handleDisplayPopup = () => {
    if (userStore.pendingBackendRecharge?.config.doubleReward === 0) {
        getClaim()
    } else {
        showIndex.value = 1
    }
}
const goToDeposit = () => {
    router.push({
        path: '/sd-topup',
        query: { batchRecharge: 'true' }
    })
}
const getClaim = () => {
    emits('getClaim')
}

onMounted(() => {
    setTimeout(() => {
        show.value = true
    }, 3500)
})


__expose({ open, close, directClose })

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      onClose: close,
      position: "center",
      "close-on-click-overlay": false,
      style: {
        minWidth: '80%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9998'

    }
    }, {
      default: _withCtx(() => [
        (showIndex.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "headImage" }, [
                _createElementVNode("img", {
                  class: "image1",
                  src: _imports_0,
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('beRecharge.freeCashback')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    class: "image2",
                    src: _imports_1,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(formatCurrency)(_unref(userStore).pendingBackendRecharge?.topUpAmount)), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, " R$ ", -1))
                  ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dashline" }, null, -1)),
                _createElementVNode("div", {
                  class: "claimButton",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDisplayPopup()))
                }, _toDisplayString(_ctx.$t('beRecharge.toReceive')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (showIndex.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "headImage" }, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                (_unref(userStore).pendingBackendRecharge?.config?.doublingMethod === 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_unref(userStore).pendingBackendRecharge?.config?.doublingMethod === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, " R$ " + _toDisplayString(_unref(formatCurrency)(_unref(userStore).pendingBackendRecharge?.topUpAmount)), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('beRecharge.anotherDeposit')), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_van_row, { class: "headBar" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_col, { span: "11" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('beRecharge.deposit')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_van_col, { span: "1" }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode(".")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_van_col, { span: "11" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('beRecharge.multiple')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(amountTemplates.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_van_row, {
                                class: "tabel_row",
                                key: index,
                                style: _normalizeStyle({
                                    backgroundColor: index % 2 === 1 ? '#feecc9' : '#fcd9c8'
                                })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_col, {
                                    span: "12",
                                    style: {"color":"#d200ff"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(formatCurrency)(item.amount)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_van_col, {
                                    span: "12",
                                    style: {"color":"#ff0000"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.from) + "X - " + _toDisplayString(item.to) + "X", 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["style"]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('beRecharge.footerText')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(userStore).pendingBackendRecharge?.config?.doublingMethod === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('beRecharge.multiplierRewards')), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('beRecharge.makeDeposit', {
                            value: _unref(userStore).pendingBackendRecharge?.config?.rechargeMultiple
                        })), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('beRecharge.win')), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(userStore).pendingBackendRecharge?.config?.displayMultiplier === 0
                                ? _unref(userStore).pendingBackendRecharge?.config?.availableMultiple
                                : _unref(userStore).pendingBackendRecharge?.config?.displayMultiplier === 1
                                    ? _unref(userStore).pendingBackendRecharge?.config?.displayFrom + '-' +
                                    _unref(userStore).pendingBackendRecharge?.config?.displayTo
                                    : '0'), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('beRecharge.bonusTime')), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('beRecharge.footerText')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_van_row, { style: {"padding":"10% 10% 5%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    style: {"padding":"0 10px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "claimBtn",
                        onClick: getClaim
                      }, _toDisplayString(_ctx.$t('beRecharge.continueToReceive')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "12",
                    style: {"padding":"0 10px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "depositBtn",
                        onClick: goToDeposit
                      }, _toDisplayString(_ctx.$t('beRecharge.multipliedReward')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "closeICon" }, [
          _createElementVNode("img", {
            class: "image1",
            src: _imports_3,
            alt: "",
            onClick: close
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})